import { Button, Modal, Form } from 'react-bootstrap';

const ModalBeRepresented = (props: any) => {
  const handleClose = () => {
    props.setShow(false);
  };

  const validate = () => {
    //Prepare data
    handleClose();
  };

  return (
    <Modal show={props.show} onHide={handleClose}>
      <div className="d-flex flex-column m-4">
        <div className='subTitleBoldConf'>
          Vous ne pourrez pas être sur place ?
        </div>
        <div className="mt-3 d-flex flex-column w-100">
          <div className='subTextConf'>Faites-vous représenter par un proche. Cette personne devra fournir les documents suivants le jour de l’état des lieux : </div>
          <ul className='subTextConf'>
            <li>Une lettre de procuration</li>
            <li>Une photocopie de votre carte d'identité</li>
            <li>La carte d'identité du représentant</li>
          </ul>
        </div>
        <div className="d-inline-flex">
            <div className=" linkCGUConf">
              Télécharger le modèle de procuration
            </div>
          </div>
          <Form.Check
            className='mt-4 subTextConf'
            type="checkbox"
            label={`Je confirme avoir pris connaissance des conditions.`}
          />
      </div>
        <div className="d-grid gap-2">
          <Button className='popupBtnConf' variant="primary" onClick={() => validate()}>
            Je me fais représenter
          </Button>
        </div>
    </Modal>
  );
};

export default ModalBeRepresented;
